import { __awaiter, __generator } from "tslib";
import { TransactionMode, } from '@tencent/memoire-core';
import { Command } from './client-msg.interface';
import { ClientProxy } from './client-proxy';
import { NativeEngineTable } from './table';
import { NativeEngineTransaction } from './transaction';
import { assertResp, getCollectionSchema } from './utils/common';
var NativeEngineDatabase = /** @class */ (function () {
    function NativeEngineDatabase(schema, dbName, version, tableNames, isSupportTransactions, engineAspects) {
        this.isSupportTransactions = isSupportTransactions;
        this.engineAspects = engineAspects;
        this.schema = schema;
        this.name = dbName;
        this.version = version;
        this.tableNames = tableNames;
        if (engineAspects === null || engineAspects === void 0 ? void 0 : engineAspects.database) {
            this.applyAspectPatch();
        }
    }
    NativeEngineDatabase.prototype.setVersionChangeListener = function () { };
    NativeEngineDatabase.prototype.close = function () { };
    /** Native db does not support incremental modification of the library table structure.
     * The full library table interface has been passed in during initialization,
     * so the table creation function does not need to be implemented */
    NativeEngineDatabase.prototype.createTable = function (tableName) {
        return new NativeEngineTable(this.name, getCollectionSchema(tableName, this.schema), TransactionMode.VERSION_CHANGE, this.engineAspects);
    };
    /** Native db does not support incremental modification of the library table structure.
     * The full library table interface has been passed in during initialization,
     * so the table deletion function does not need to be implemented */
    NativeEngineDatabase.prototype.deleteTable = function () {
        return;
    };
    NativeEngineDatabase.prototype.transaction = function (tableNames, mode) {
        return __awaiter(this, void 0, void 0, function () {
            var req, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // native db old version don't support transaction, create fake transaction;
                        // if mode is readonly, we don't need to open transaction which will has open request cost
                        if (!this.isSupportTransactions || mode === TransactionMode.READ_ONLY) {
                            return [2 /*return*/, new NativeEngineTransaction(tableNames, this.name, this.schema, undefined, mode !== null && mode !== void 0 ? mode : TransactionMode.READ_ONLY, this.engineAspects)];
                        }
                        req = {
                            command: Command.BEGIN_TRANSACTION,
                            dbName: this.name,
                        };
                        return [4 /*yield*/, ClientProxy.send(req)];
                    case 1:
                        resp = _a.sent();
                        assertResp(resp, 'startTransaction');
                        return [2 /*return*/, new NativeEngineTransaction(tableNames, this.name, this.schema, resp.result, mode !== null && mode !== void 0 ? mode : TransactionMode.READ_ONLY, this.engineAspects)];
                }
            });
        });
    };
    NativeEngineDatabase.prototype.table = function (tableName, mode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new NativeEngineTable(this.name, getCollectionSchema(tableName, this.schema), mode, this.engineAspects)];
            });
        });
    };
    /**
     * bind the hook stub to the database object
     */
    NativeEngineDatabase.prototype.applyAspectPatch = function () {
        var _a;
        var databaseAspect = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.database;
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.deleteTable.patch(this, 'deleteTable');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.createTable.patch(this, 'createTable');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.transaction.patch(this, 'transaction');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.table.patch(this, 'table');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.close.patch(this, 'close');
    };
    return NativeEngineDatabase;
}());
export { NativeEngineDatabase };
//# sourceMappingURL=database.js.map